import { render, staticRenderFns } from "./SearchDocumentInfo.vue?vue&type=template&id=936c67ea&"
import script from "./SearchDocumentInfo.vue?vue&type=script&lang=js&"
export * from "./SearchDocumentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports